import { PX } from './constants';

// TODO: we should be determining the max-width based on flex behaviors and not computing it.
export const getTitleMaxWidth = (maxWidth) => {
  return maxWidth ? maxWidth - PX * 4 : undefined;
};
